// extracted by css-extract-rspack-plugin
export default {"wrapper":"_740ca597","image":"_dd5fd2a3"};